const ArrowLineSvg = ({
  height = 11,
  width = 29,
  viewBox = '0 0 29 11',
}: {
  height?: number;
  width?: number;
  viewBox?: string;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <rect y="4.60693" width="27" height="1" fill="#5D5E69" />
      <rect y="4.60693" width="27" height="1" fill="url(#paint0_linear)" />

      <path d="M24 0.607054L28 5.10699L25.5 5.107L24 0.607054Z" fill="#F54900" />
      <path d="M22 2.60693L25 4.60693L23 4.60693L22 2.60693Z" fill="#F54900" />
      <path d="M25.5253 5.10443L28.0254 5.10456L24.0267 9.60206L25.5253 5.10443Z" fill="#F54900" />
      <path d="M23 5.60693L25 5.60693L22 7.60693L23 5.60693Z" fill="#F54900" />

      <defs>
        <linearGradient
          id="paint0_linear"
          x1="0"
          y1="5.10693"
          x2="27"
          y2="5.10693"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5A5B65" />
          <stop offset="1" stopColor="#F54900" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ArrowLineSvg;
